import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";

interface SuggestionListProps {
  suggestions: { label: string; data: any }[];
  onSelect: (item: { label: string; data: any }) => void;
  inputValue: string;
}

export interface SuggestionListRef {
  show: () => void;
  hide: () => void;
}

const SuggestionList = forwardRef<SuggestionListRef, SuggestionListProps>(
  ({ suggestions, onSelect, inputValue }, ref) => {
    const [showSuggestions, setShowSuggestions] = useState<boolean>(false);
    const containerRef = useRef<HTMLUListElement | null>(null);

    useImperativeHandle(ref, () => ({
      show: () => setShowSuggestions(true),
      hide: () => setShowSuggestions(false),
    }));

    const filteredSuggestions = suggestions.filter(
      (item) =>
        inputValue &&
        item.label.toLowerCase().includes(inputValue?.toLowerCase())
    );

    if (!showSuggestions || filteredSuggestions.length === 0) return null;

    return (
      <ul
        ref={containerRef}
        className="absolute top-full mt-1 border border-gray-200 left-0 right-0 max-h-72 bg-white shadow-md rounded-lg overflow-y-auto z-40"
      >
        {filteredSuggestions.map((item, index) => (
          <li
            key={index}
            className="cursor-pointer p-2 hover:bg-gray-200"
            onClick={() => {
              onSelect(item);
              setShowSuggestions(false);
            }}
          >
            {item.label}
          </li>
        ))}
      </ul>
    );
  }
);

export default SuggestionList;
